import Box from "@mui/material/Box";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";

import { ProductCategory } from "services/types/product-categories.type";

export type ProductCategoryFilterValue = number | "";

const ALL = "all";

interface ProductCategoryFilterProps {
  categories: ProductCategory[];
  value: ProductCategoryFilterValue;
  onChange: (value: ProductCategoryFilterValue) => void;
  labelledBy: string;
  disabled?: boolean;
}

// Every category is one click away; a long list scrolls sideways rather than
// hiding behind a dropdown.
export default function ProductCategoryFilter({
  categories,
  value,
  onChange,
  labelledBy,
  disabled = false
}: ProductCategoryFilterProps) {
  return (
    <Box
      data-testid="product-category-filter-scroll"
      sx={{ overflowX: "auto", maxWidth: "100%", minWidth: 0, pb: 0.5 }}
    >
      <ToggleButtonGroup
        size="small"
        exclusive
        aria-labelledby={labelledBy}
        value={value === "" ? ALL : String(value)}
        disabled={disabled}
        onChange={(_, next: string | null) => {
          // Clicking the pressed button returns null; keep the current choice.
          if (next === null) return;
          onChange(next === ALL ? "" : Number(next));
        }}
      >
        <ToggleButton value={ALL}>All</ToggleButton>
        {categories.map((category) => (
          <ToggleButton
            key={category.id}
            value={String(category.id)}
            sx={{ whiteSpace: "nowrap" }}
          >
            {category.name}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Box>
  );
}
